import { Reference } from './reference';
import { Newable } from '../../interfaces/newable.interface';

interface CallType {
  method: string,
  parameters: unknown[] | Reference[];
}

export class Definition<T = unknown> {
  private cls?: Newable<T>;
  private tags: Set<string> = new Set();

  private readonly calls: CallType[] = [];

  public constructor (cls?: Newable<T>, parameters = []) {
    if (cls) {
      this.setClass(cls);
    }
  }

  public getClass (): Newable<T> {
    if (!this.cls) {
      throw new Error('Class name must be defined');
    }

    return this.cls;
  }

  public setClass (cls: Newable<T>): this {
    this.cls = cls;

    return this;
  }

  public setMethodCalls (calls: CallType[] = []): this {
    for (const call of calls) {
      this.addMethodCall(call.method, call.parameters);
    }

    return this;
  }

  public addMethodCall (method: string, parameters: CallType['parameters'] = []): this {

    this.calls?.push({ method, parameters });

    return this;
  }

  public removeMethodCall (method: string): this {
    for (let i = 0; i < this.calls.length; i++) {
      const call = this.calls[ i ];

      if (call.method === method) {
        this.calls.splice(i, 1);
      }
    }

    return this;
  }

  public hasMethodCall (method: string): boolean {
    for (let i = 0; i < this.calls.length; i++) {
      const call = this.calls[ i ];

      if (call.method === method) {
        return true;
      }
    }

    return false;
  }

  public getMethodCalls (): CallType[] {
    return this.calls;
  }

  public setTags (tags: string[]): this {
    this.tags = new Set(tags);

    return this;
  }

  public hasTag (name: string): boolean {
    return this.tags.has(name);
  }

  public getTags (): string[] {
    return [ ...this.tags ];
  }

  public addTag (tag: string): this {
    this.tags.add(tag);

    return this;
  }

  public clearTag (name: string): this {
    this.tags.delete(name);

    return this;
  }

  public clearTags (): this {
    this.tags = new Set();

    return this;
  }
}
